/** Strip colons, hyphens, dots, and spaces so "AA:BB:CC:DD:EE:FF" becomes "AABBCCDDEEFF" */
export const normalizeMac = (mac: string) => mac.replace(/[:\-.\s]/g, '').trim()

/** Format a bare MAC like "AABBCCDDEEFF" as "AA:BB:CC:DD:EE:FF" for display */
export const formatMac = (mac: string): string => {
  const bare = normalizeMac(mac).toUpperCase()
  return bare.length === 12 ? bare.match(/.{2}/g)!.join(':') : mac
}

const MAC_WITH_SEPARATORS =
  /^[0-9a-f]{2}([:\-.])[0-9a-f]{2}\1[0-9a-f]{2}\1[0-9a-f]{2}\1[0-9a-f]{2}\1[0-9a-f]{2}$/i

/**
 * If `term` looks like a MAC address with separators (e.g. "AA:BB:CC:DD:EE:FF"),
 * strip the separators so the backend can match its bare-MAC storage format.
 * Non-MAC searches pass through unchanged.
 */
export const normalizeSearchTerm = (term: string): string => {
  const trimmed = term.trim()
  return MAC_WITH_SEPARATORS.test(trimmed) ? normalizeMac(trimmed) : trimmed
}
